<template>
  <v-main
    id="content"
  >
    <v-row justify="center">
      <v-col
        class="text-center"
        cols="12"
        md="4"
      >
        <v-progress-circular
          v-if="loading"
          :size="50"
          color="primary"
          indeterminate
        />
        <h4
          v-else
          class="title font-weight-light mb-2"
        >
          A site is required for this page
        </h4>
      </v-col>
    </v-row>
    <v-row
      v-if="sites && sites.length > 0"
      justify="center"
      class="mx-0"
    >
      <v-col
        cols="12"
        md="4"
      >
        <v-select
          v-model="siteName"
          solo
          label="Site"
          hide-details
          :items="sites.map(site => site.name)"
          @change="() => setSite(siteName)"
        />
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
  export default {
    props: {
      loading: {
        type: Boolean
      }
    },
    data () {
      return {
        siteName: null
      }
    },
    computed: {
      sites: function () {
        return this.$store.state.sites
      },
    },
    methods: {
      setSite (name) {
        var siteId = this.sites.find(site => site.name === name).siteId
        this.$store.commit('setSite', siteId)
      },
    }
  }
</script>
